import React, { useCallback } from 'react';
import { useDispatch } from 'react-redux';
import { Link, useLocation } from 'react-router-dom';

import type { ImmutableTrip } from 'src/types/trips/Trips';
import { open } from '../../../common/ducks/zippy';
import { PAGES } from '../../constants';
import { CANCEL_INQUIRY } from '../TripMenu/actions';
import ClearButton from '../../../common/components/ClearButton';
import UserBlock from '../presentation/UserBlock';
import { appendRoute, preserveSearch } from '../../../common/utils/routing';

type RenterCustomOfferExpiredMessageProps = {
  trip: ImmutableTrip;
};

const RenterCustomOfferExpiredMessage = ({ trip }: RenterCustomOfferExpiredMessageProps) => {
  const location = useLocation();
  const {
    name: modalName,
  } = CANCEL_INQUIRY;
  const dispatch = useDispatch();
  // This dispatches an action to open the CANCEL_INQUIRY modal,
  // which is defined and rendered by TripMenu when TripMenu is mounted,
  // with the cancel the inquiry form.
  const openModal = useCallback(
    () => dispatch(open(modalName)),
    [dispatch, modalName],
  );

  return (
    <UserBlock user={trip.get('owner')}>
      <strong>
        Your offer from {trip.getIn(['owner', 'first_name'])} expired because its expiry date has now passed.
      </strong>
      {' '}
      <Link
        to={preserveSearch(appendRoute(location.pathname, PAGES.MESSAGES), location)}
      >
        Send a message
      </Link>
      {' '}
      to request a new offer or
      {' '}
      <ClearButton
        classNameModifier="inline"
        onClick={openModal}
      >
        cancel your inquiry
      </ClearButton>
      {' '}
      if you are no longer interested.
    </UserBlock>
  );
};

export default RenterCustomOfferExpiredMessage;
